import { truncate } from 'lodash'
import React, { useState, useEffect } from 'react'
import ConfirmationModal from '../Helpers/Modal/ConfirmationModal'
import { array } from 'prop-types'

export default function CommunityList({ communities, team, communityPlural, isManager, user, pages, pages_flag, show_page}) {
    const [currentFilter, setCurrentFilter] = useState(null)
    const [filteredCommunities, setFilteredCommunities] = useState(communities)
    const [openBlocked, setOpenBlocked] = useState(false)

    useEffect(() => {
        if (!currentFilter) {
            if (filteredCommunities && filteredCommunities.length > 0) {
                setCurrentFilter(0)
            } else {
                setCurrentFilter(1)
            }
        }
    }, [currentFilter])

    const changeFilter = (num) => {
        setCurrentFilter(num)
    }

    const handleOpen = (community) => {
        if (community.blocked_members && community.blocked_members.includes(user.id)) {
            setOpenBlocked(true)
            return
        }

        window.location = `/pages/${community.id}`
    }

  return (
    <React.Fragment>
        {/* Filters page links */}
        <div className="overflow">
            <div className="nav nav-line nav-sub nav-color-secondary">
                    {filteredCommunities && filteredCommunities.length > 0 &&
                    <a className={currentFilter == 0 ? 'nav-link active show' : 'nav-link'} href="#" onClick={() => changeFilter(0)}>
                        All { communityPlural }
                    </a>    
                    }
                    {user.user_type == 'donor' && pages && pages.length > 0 && pages_flag &&
                        <a className={currentFilter == 1 ? 'nav-link active show' : 'nav-link'} href="#" onClick={() => changeFilter(1)}>
                            All Public Pages
                        </a>
                    }
            </div>
        </div>

        {/* Main content area */}
        {currentFilter == 0 && filteredCommunities && filteredCommunities.length > 0 &&
            <div className="card">
            <div>
                <div className="list-group list-group-flush">
                    {filteredCommunities.map((community) => (
                        <div style={{border: '1px solid #ebecec'}}>
                            <div className="list-group-item">
                                <div className='list-group-item-body'>
                                    <div className='list-group-item-body-main-invoices' >
                                        <div className="list-item-title-segment">
                                            <span style={{fontWeight: 'bold'}}>{team.community_title} Name: </span>{community.title}
                                        </div>
                                        <div className="list-item-title-segment d-none-mobile">
                                            <span style={{fontWeight: 'bold'}}>Members: </span>{community.members.length}
                                        </div>
                                        <div className="list-item-total d-none-mobile">
                                            <span style={{fontWeight: 'bold'}}>Messages: </span> {community.messages.length}
                                        </div>
                                    </div>
                                </div>

                                <div className='list-group-item-actions'>
                                    <a href={"#"} className="btn btn-sm btn-outline-primary" onClick={() => handleOpen(community)}>
                                        Enter {team.community_title}
                                    </a>
                                </div>
                        </div>
                    </div>
                ))}
            </div>

            </div>
                {filteredCommunities.length == 0 &&
                    <div className="card-body">
                        {!isManager && <span>No attached {team.community_title} at the moment :)</span>}
                    </div>
                }
        </div>
        }

        {currentFilter == 1 && pages && pages.length > 0 && user.user_type == 'donor' && pages_flag &&
            <div className="card">
            <div>
                <div className="list-group list-group-flush">
                    {pages.map((page) => (
                        <div style={{border: '1px solid #ebecec'}}>
                            <div className="list-group-item">
                                <div className='list-group-item-body'>
                                    <div className='list-group-item-body-main-invoices' >
                                        <div className="list-item-title-segment">
                                            <span style={{fontWeight: 'bold'}}>{page.title}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className='list-group-item-actions'>
                                    <a href={page.url} target="_blank" className="btn btn-sm btn-outline-primary">
                                        View Page
                                    </a>
                                </div>
                        </div>
                    </div>
                ))}
            </div>

            </div>
        </div>
        }

            {openBlocked &&
                <ConfirmationModal cancel={() => setOpenBlocked(false)} message={`You have been blocked from accessing this ${team.community_title.toLowerCase()}, please contact the team at ${team.name}`} />
            }
    </React.Fragment>
  )
}

